
import { getOssDomainAndWebpSuffix } from '@/utils/ossDomain'

const GRAY_IMG = 'https://resources1.interface003.com/web20/img/default/article.png'
const DEALER_AD_IMG = 'https://resources1.interface003.com/web20/img/dealer/bg-792.png'

export default {
  name: 'WikiImg',
  props: {
    src: {
      type: String,
      default: '',
      required: true,
    },
    errorSrc: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    fetchpriorityFlag: {
      type: Boolean,
      default: false,
    },
    fromDealer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSrc: this.getProcessedSrc(this.src),
    }
  },
  computed: {
    defaultImg() {
      return this.fromDealer ? DEALER_AD_IMG : GRAY_IMG
    },
  },
  watch: {
    src(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentSrc = this.getProcessedSrc(newVal)
      }
    },
  },
  mounted() {
    this.loadImage(this.src)
  },
  methods: {
    getProcessedSrc(src) {
      // console.log('wiki-img传入的Src:', src)
      if (!src) {
        return this.errorSrc || this.defaultImg
      }
      // 如果src是.webp结尾，则直接返回
      if (src.toLowerCase().endsWith('.webp')) {
        return src
      }
      const suffix = getOssDomainAndWebpSuffix(src)
      if (!suffix) {
        return src
      }
      // 如果src最后已经是suffix结尾，则不再添加
      if (src.toLowerCase().endsWith(suffix.toLowerCase())) {
        return src
      }

      const m = src.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/)
      const path = m ? m[1] : src
      const query = m && m[2] ? m[2] : ''
      if (path.toLowerCase().endsWith('.svg') || !suffix) {
        return path + query
      }
      return path + suffix + query
    },
    loadImage(src) {
      if (!src) {
        this.currentSrc = this.errorSrc || this.defaultImg
        return
      }
      const webpSrc = this.getProcessedSrc(src)
      if (webpSrc === src) {
        this.tryOriginal(src)
        return
      }
      this.currentSrc = webpSrc
    },
    handleError(e) {
      // console.log('Image load error:', e)
      const failedSrc = e.target.src
      const originalSrc = this.src
      const webpSrc = this.getProcessedSrc(originalSrc)
      if (failedSrc === webpSrc) {
        this.tryOriginal(originalSrc)
      } else if (failedSrc === originalSrc) {
        this.currentSrc = this.errorSrc || this.defaultImg
      }
    },
    tryOriginal(src) {
      this.currentSrc = src
    },
  },
}
